export default class WizardCloudHandler {
  form;

  config = {
    routes: {
      link: '',
      import: '',
      process: '',
    },
  };

  constructor(form, config = {}) {
    this.form = form;
    Object.assign(this.config, config);
  };

  async handle() {
    const link = await this.getSignedLink();
    await this.uploadFile(link);
    await this.processFile();
  }

  async getSignedLink() {
    const route = this.config.routes.link;
    let fileName = this.form.file.name;
    let contentType = this.form.file.type;
    if (contentType === '') {
      // ContentType for csv can be an empty string...
      if (fileName.endsWith('csv')) {
        contentType = 'text/csv';
      }
    }
    const response = await this.form.submit('get', route, {
      params: {
        'fileName': fileName,
        'contentType': contentType,
        'origin': location.origin,
      },
    });
    return response.link;
  }

  uploadFile(signedCloudLink) {
    return this.form.submit('put', signedCloudLink, {
      headers: {
        'Content-Type': this.form.file.type,
      },
    }, this.form.file);
  }

  processFile() {
    const route = this.config.routes.process;
    const config = {
      params: {
        'fileName': this.form.file.name,
      },
    };
    this.form.file = '';

    return this.form.submit('post', route, config)
  }
}
